<script setup lang="ts">
const props = defineProps({
    compilations: {
        type: Array as PropType<string[]>,
        default: () => []
    },
    title: {
        type: String,
        default: ''
    }
});

const compilationActive = ref<any>(null); // Initialize as null

const { data: compilationsList } = await useFetchProxyApi(`/api/media/compilations`, {
    params: {
        select: ['id', 'name', 'code', 'items'],
        filter: {
            code: props.compilations
        }
    },

    transform: (response: any) => {
        const sortOrderIndexes = Object.fromEntries(props.compilations.map((item, index) => [item, index]));
        // Сортируем первый массив с использованием функции сравнения
        const result = response?.data?.items?.sort((a: any, b: any) => {
            const indexA = sortOrderIndexes[a.code] ?? Infinity;
            const indexB = sortOrderIndexes[b.code] ?? Infinity;
            return indexA - indexB;
        });

        return result;
    }
});

compilationActive.value = compilationsList.value?.[0];

const setCompilationActive = (data: any) => {
    const existingCompilation = compilationsList.value.find((item: any) => item.code === data.code);
    if (existingCompilation) {
        compilationActive.value = existingCompilation;
    } else {
        useLogger('COMPILATION_FILTER_NOT_FOUND_SECTION');
    }
};

const compilationListNode = ref();
const onRegisterCompilationList = (node: any) => (compilationListNode.value = node);

// Вызываем LRUD и отсматриваем фокус
const { $lrud } = useNuxtApp();
const isActvieListFocus = ref(false);
const onFocusLrud = (event: any) => {
    if (compilationListNode.value) {
        const compilationListElement = document.getElementById(compilationListNode.value?.id);
        isActvieListFocus.value = !!compilationListElement?.querySelector('#' + event?.id);
    }
};

// Добавляем и удаляем коллбеки для действий
onMounted(() => {
    $lrud.base.emitter.on('focus', onFocusLrud);
});
onBeforeUnmount(() => {
    $lrud.base.emitter.off('focus', onFocusLrud);
});

const selected = (dataItem: any) => {
    navigateTo(dataItem.data?.item ? useUrl(dataItem.data.item, dataItem.data.type, compilationActive.value.id) : null);
};
</script>

<template>
    <h2 v-if="props.title" class="title fs-30 fs_m-24 mb-24">{{ props.title }}</h2>
    <LrudNode
        class="carousel-filter-compilation__list"
        :class="{ 'carousel-filter-compilation__list_active': isActvieListFocus }"
        @register="onRegisterCompilationList"
    >
        <CarouselBaseHorizontal :items="compilationsList" @focused="(e) => setCompilationActive(e.data)">
            <template #default="{ data }">
                <LrudNode isFocusable class="carousel-filter-compilation">
                    <FilterButton
                        :text="data.name"
                        :value="data.id"
                        :isChecked="compilationActive?.code === data.code"
                    />
                </LrudNode>
            </template>
        </CarouselBaseHorizontal>
    </LrudNode>

    <LrudNode class="mt-24">
        <CarouselBaseHorizontal :key="compilationActive?.code" :items="compilationActive?.items" @selected="selected">
            <template #skeleton>
                <div class="media-preview media-preview_blocked">
                    <span class="media-preview__image">
                        <span class="media-preview__image-placeholder"></span>
                    </span>
                    <span class="media-preview__name title fs-20 mt-16"></span>
                </div>
            </template>
            <!-- item -->
            <template #default="{ data }">
                <MediaPreview :type="data?.type" :item="data?.item" />
            </template>
        </CarouselBaseHorizontal>
    </LrudNode>
</template>

<style lang="scss">
.carousel-filter-compilation__list {
    .filter-button.is-active {
        background: inherit;
        color: #fff;
    }

    .carousel-filter-compilation.lrud_focused {
        transform: scale(1.1);
    }

    .carousel-filter-compilation.lrud_focused .filter-button {
        background-color: #ffffff;
        color: $main-black;
    }
}
</style>
